import {
  ApplyAdvanceInput,
  MoneyInput,
  PaymentApplicationType,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type AdvanceApplyParams = {
  paymentId: string;
  documentId: string;
  documentType: 'Bill' | 'Invoice';
  appliedAmount: MoneyInput;
};

export const advanceApplyAtom = createMutationAtomFactory(
  'finance.advanceApply',
  (params: AdvanceApplyParams) => {
    const input: ApplyAdvanceInput = {
      paymentId: params.paymentId,
      documentId: params.documentId,
      documentType: params.documentType as PaymentApplicationType,
      appliedAmount: params.appliedAmount,
    };

    return {
      financeAdvanceApply: {
        __args: {
          input,
        },
        id: true,
        status: true,
        unappliedAmount: {
          amount: true,
          currencyCode: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
